import { React, useState, useEffect } from "react";
import { BASE_URL } from "../env";
import style from "../Assets/css/adminSlider.module.css";
import { store } from "react-notifications-component";

const CourseVideo = () => {
	const [videoUrl, setVideoUrl] = useState("");
	const [courses, setCourses] = useState([]);
	const [course, setcourse] = useState("");

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
				console.log(data?.courses);
			});
	}, []);

	const uploadingTheVideo = async (e) => {
		const data = {
			videoUrl: videoUrl,
			courseId: course,
		};
		const notifyPopup = () => {
			store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		await fetch(BASE_URL + "/uploadVideo", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify(data),
		})
			.then((res) => res.json())
			.then((data) => {
				notifyPopup();
				console.log(data);
			});
	};

	return (
		<>
			<div className={style.adminSliderPage}>
				<div className={style.adminSliderCard}>
					<div className={style.adminSliderCardHeading}>
						Upload Video
					</div>
					<form
						className={style.adminSliderform}
						onSubmit={uploadingTheVideo}
					>
						<input
							type="text"
							className={`form-control ${style.adminSliderCardField}`}
							placeholder="Enter The Video Url"
							value={videoUrl}
							onChange={(e) => {
								setVideoUrl(e.target.value);
								console.log(videoUrl);
							}}
						/>

						<select
							className={`form-control ${style.adminSliderCardField}`}
							aria-label="Default select example"
							video=""
							id=""
							value={course}
							onChange={(e) => {
								setcourse(e.target.value);
								console.log(course);
							}}
						>
							<option value="">Select Course</option>
							{courses.map((val) => {
								return (
									<option value={val?._id}>
										{val?.name}
									</option>
								);
							})}
						</select>
						<button
							type="submit"
							className={`btn ${style.adminSliderFormBtn}`}
						>
							Submit
						</button>
					</form>
				</div>
			</div>
		</>
	);
};

export default CourseVideo;
